export const TM = {
  LOCAL_CUSTOM_EVENT_LOG: "🎄",
};
